/** basic.patrolRecord */
export default {
    record_upLoadingServer: "Загрузить на сервер",
    record_dialogTitle: "Новая запись инспекции",
    record_site: "Объект",
    record_belongTask: "Выберите задачу",
    record_inspectionResult: "Результат инспекции",
    record_inspectionResultPla: "Выберите результат инспекции",
    record_problemDesc: "Описание проблемы",
    record_ruleSite: "Выберите связанный объект",
    record_ruletask: "Выберите задачу",
    record_RuleInspectionResult: "Выберите результат инспекции",
    record_ruleRroblemDesc: "Введите описание проблемы",
}

